

export class ResponsePageInfo {

  protected totalResults: number;
  protected RBP: number;
  protected page: number;

  constructor(rawPageInfo: any) {
    this.totalResults = rawPageInfo.totalResults;
    this.RBP = rawPageInfo.RBP;
    this.page = rawPageInfo.page;
  }

  public getCurrentPage() {
    return this.page;
  }

  public getResultsPerPage() {
    return this.RBP;
  }

  public getTotalResults() {
    return this.totalResults;
  }

}